<template>
  <div class="app">
    <Loading :value="loading"></Loading>
  	<!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item icons router :to='item.path' v-for="item in racourcis" :key="item.text" :disabled="item.disabled">
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br>

    <!-- MODAL AJOUT DE USER -->
    <v-dialog v-model="dialogAjout" max-width="80%" :overlay="true" scrollable persistent>
    	<v-card>
      	<v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajouter un nouvel utilisateur</span>
            <span v-if="dialogEdit">Modification de l'utilisateur {{userCourant.nom}} </span>
          </v-toolbar-title>
        	<v-spacer></v-spacer>
        	<v-btn icon @click.native="dialogAjout = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

    	  <v-card-text v-loading="loading" element-loading-text="En cours d'enregistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-container fluid grid-list-md>
            <v-form v-model="valid" ref="formUser" lazy-validation id="formUser">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-card class="box-card" style="background:#fff">
                      <div>
                        <v-flex xs12 sm4  class="text-xs-center">
                            <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="logoUser" alt="avatar"></v-avatar><br/>
                            <input name="photo" type="file" style="display:none" ref="fileLogo" accept="image/*" @change="onFileImageLogoPicked"/>
                            <v-btn color="primary" class="white--text" required @click.native="$refs.fileLogo.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn><br/>
                        </v-flex>
                      </div>
                    </el-card>
                  </div>
                </el-col>
                <el-col :span="18" >
                  <div class="grid-content" style="padding:3px">
                    <el-row>
                      <el-col>
                        <div class="grid-content bg-purple">
                          <el-card class="box-card" style="background:#fff">
                            <v-layout row justify>
                              <v-flex md4>
                                <v-text-field label="Nom et prénoms" name="nomUser" v-model="nomUser" :rules="nomUserRules" :counter="4" required>
                                </v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-text-field label="Login de connexion" name="loginUser" v-model="loginUser" :rules="[(v) => !!v || 'Le login est obligatoire']" required>
                                </v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-text-field label="E-mail" name="emailUser" v-model="emailUser" :rules="loginUserRules" :counter="6" required>
                                </v-text-field>
                              </v-flex>
                            </v-layout>

                            <v-layout row justify>
                              <v-flex md4>
                                <v-text-field name="contactUser" min="0" label="Contact" v-model="contactUser" :counter="8" :rules="contactUserRules" hint="Exemple: 00-00-00-00" persistent-hint required></v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-text-field label="Fonction occupé" name="fonctionUser" v-model="fonctionUser" :counter="6" required></v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-select label="Services" name="serviceUser" v-bind:items="listService" v-model="selectServiceUser" :rules="serviceUserRules" item-value="id" item-text="libelle" ></v-select>
                              </v-flex>
                            </v-layout>

                            <v-layout row justify>
                              <!-- <v-flex md4>
                                <v-select :disabled="dialogEdit" label="Type d'utilisateur" name="serviceUser" v-bind:items="typeUser" v-model="selectTypeUser" :rules="[(v) => !!v || 'Veuillez sélectionner le type.']" item-value="value" item-text="text" ></v-select>
                              </v-flex> -->
                              <v-flex md4 v-if="selectTypeUser === 2">
                                <v-select label="Poste occupé" name="serviceUser" v-bind:items="posteUser" v-model="selectPosteUser" :rules="[(v) => !!v || 'Veuillez sélectionner le poste.']" item-value="value" item-text="text"></v-select>
                              </v-flex>
                            </v-layout>

                            <p align="center">
                              <v-chip text-color="white" label color="primary" style="width: 100%">
                                PARAMETRE DE CONNEXION
                              </v-chip>
                            </p>

                            <v-layout row justify>
                              <v-flex md4 v-if="dialogEdit != true">
                                <v-text-field type="password" name="mdpUser" label="Mot de passe" v-model="mdpUser" :rules="mdpUserRules" :counter="4" required></v-text-field>
                              </v-flex>
                              <v-flex md4 v-if="dialogEdit">
                                <v-text-field type="password" name="mdpUserConnect" label="Votre mot de passe" v-model="mdpUserConnect" :rules="mdpUserConnectRules" :counter="4" required></v-text-field>
                              </v-flex>
                              <v-flex md4 v-if="dialogEdit != true">
                                <v-text-field type="password" name="mdpVerUser" label="Confirmer le mot de passe" v-model="mdpVerUser" :rules="mdpVerUserRules" :counter="4" required></v-text-field>
                              </v-flex>
                            </v-layout>
                          </el-card>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <br/>
                </el-col>
              </el-row>

          	  <v-btn @click="clear" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons color="blue" @click="submit" :disabled="!valid" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
            </v-form>
          </v-container>
    	  </v-card-text>
      	<div style="flex: 1 1 auto;"></div>
    	</v-card>
    </v-dialog>

    <!-- MODAL AJOUT NOUVEAU GROUPE -->
    <v-dialog v-model="dialogAjoutGroupe" max-width="50%" :overlay="true" scrollable persistent>
    	<v-card>
      	<v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span v-if="editGroup != true">Ajouter un groupe</span>
            <span v-if="editGroup">Modification le groupe </span>
          </v-toolbar-title>
        	<v-spacer></v-spacer>
        	<v-btn icon @click.native="dialogAjoutGroupe = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

    	  <v-card-text v-loading="loading" element-loading-text="En cours d'enregistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-container fluid grid-list-md>

            <v-form id="formGroup" ref="formGroup" lazy-validation>
              <v-text-field name="libelle" v-model="formGroupe.libelle" :rules="GroupLIbRules" label="Libelle" required></v-text-field>
              <v-textarea name="description" textarea v-model="formGroupe.description" label="Description"></v-textarea>

              <v-btn color="primary" @click="SaveGroupe()">
                Enregistrer
              </v-btn>
            </v-form>

          </v-container>
    	  </v-card-text>
      	<div style="flex: 1 1 auto;"></div>
    	</v-card>
    </v-dialog>


    <!-- MODAL AJOUT DES OERMISSIONS ROLES PAR GROUPE -->
    <v-dialog v-model="dialogAttRole" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="orange">
          <v-toolbar-title>
            <span>Ajouter des permissions d'accès</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAttRole = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-container fluid grid-list-md>
            <p align="center">
              <v-chip text-color="white" label color="orange" style="font-size:22px; width:100%">
                ATTRIBUER DES ACCES MENUS AU GROUPE
              </v-chip>
            </p>
            <!-- ESPACE ROLES ACCES MENUS -->
            <v-layout justify-center row>
                <el-transfer filterable :titles="['Liste des menus', 'Menu(s) du groupe']"
                  :button-texts="['Retirer', 'Ajouter']"  v-model="menusGrpActu" :data="allRoleMenus">
                </el-transfer>
            </v-layout>


              <p align="center">
                <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                  ATTRIBUER DES ACCES ROUTES AU GROUPE
                </v-chip>
              </p>
              <!-- ESPACE ROLES ACCES ROUTES -->
              <v-layout justify-center row>
                  <el-transfer filterable :titles="['Liste des routes', 'Route(s) du groupe']"
                    :button-texts="['Retirer', 'Ajouter']"  v-model="routesGrpActu" :data="allRoleRoutes">
                  </el-transfer>
              </v-layout>

              <v-btn @click="dialogAttRole = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons color="blue" @click="submitAttRoles" dark>Valider la modification <v-icon right>add</v-icon></v-btn>

          </v-container>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


<!-- MODAL AJOUT DES ROLES -->
    <v-dialog v-model="dialogRole" max-width="60%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="orange">
          <v-toolbar-title>
            <span>Ajouter des droits d'accès</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogRole = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-container fluid grid-list-md>
            <p align="center">
              <v-chip text-color="white" label color="orange" style="font-size:22px; width:100%">
                ATTRIBUER DES ROLES A L'UTILISATEUR
              </v-chip>
            </p>

            <v-form v-model="valid" ref="formRole" lazy-validation id="formRole">
              <!-- <v-layout row justify>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Accès au dashbord</span>
                    <el-select filterable multiple v-model="menuSele" placeholder="Catégorie" style="width: 100%">
                      <el-option v-for="item in menu" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Attribuer des roles</span>
                    <el-select filterable multiple v-model="role" placeholder="Catégorie" style="width: 100%">
                      <el-option v-for="item in roles" :key="item.id" :label="item.description" :value="item.id"></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout> -->

              <v-layout row justify>
                <v-flex md12>
                  <div class="block">
                    <span class="demonstration">Attribuer des groupes</span>
                    <el-select filterable multiple v-model="selectedGroup" placeholder="Selectionner les groupes" style="width: 100%">
                      <el-option v-for="(item) in listeGroupes" :key="item.id" :label="item.libelle" :value="item.id"></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-btn @click="dialogRole = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons color="blue" @click="submitRole" v-if="selectedGroup.length !== 0" dark>Ajouter <v-icon right>add</v-icon></v-btn>
            </v-form>
          </v-container>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


    <!-- MODAL SHOW -->
    <v-dialog v-model="dialogShow" max-width="90%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Détails de l'utilisateur {{userCourant.nom}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShow = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>
        <v-card-text>
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <el-card class="box-card"  style="background:#F9FAFC">
                  <div slot="header" class="carte-header">
                    <v-flex text-xs-center layout align-center justify-center>
                      <v-avatar size="140px" class="grey lighten-4">
                        <img v-if="detailUser.url" :src="detailUser.url" class="lazy" alt="">
                        <img v-else :src="logoUser" class="lazy" alt="">
                      </v-avatar>
                    </v-flex>
                  </div>
                  <div class="text item">
                    <p><b>Nom et prénoms : </b> {{detailUser.nom}} </p>
                    <p><b>Login :</b> {{detailUser.username}} </p>
                    <p><b>Email :</b> {{detailUser.email}} </p>
                    <p><b>Fonction :</b> {{detailUser.fonction}} </p>
                    <p><b>Service :</b> {{detailUser.service}} </p>
                    <p><b>Contact :</b> {{detailUser.telephone}} </p>
                    <p><b>Date d'enrégistrement :</b> {{detailUser.created}}</p>
                    <p><b>Date de modification :</b> {{detailUser.modified}}</p>
                  </div>
                </el-card>
              </div>
            </el-col>

            <el-col :span="16" >
              <div class="grid-content bg-purple">
                <v-tooltip top>
                  <v-btn v-if="droitAcces.admin_profil_update_user && userCourant.type === 1 || userCourant.type === 2" slot="activator" icons color="primary" @click.stop="editUser(userCourant);" dark>Modifier <v-icon right>edit</v-icon></v-btn>
                  Modifier
                </v-tooltip>

                <v-tooltip top>
                  <v-btn slot="activator" icons color="orange" @click.stop="newRole(detailUser);" dark>Modifier <v-icon right>vpn_key</v-icon></v-btn>
                  Droit d'accès
                </v-tooltip>

                <v-tooltip top>
                  <v-btn slot="activator" icons color="red" @click.stop="submitResetPassword();" dark>Reinitialiser le mot de passe <v-icon right>lock</v-icon></v-btn>
                  Reinitialiser le mot de passe de l'utilisateur
                </v-tooltip>

                <v-tooltip top>
                  <v-btn slot="activator" icons color="red" @click.stop="dialogMdp = true;" dark> Attribuer un nouveau  mot de passe  <v-icon right>lock</v-icon></v-btn>
                  Attribuer un nouveau  mot de passe 
                </v-tooltip>
              </div>
              <div class="grid-content" style=" padding: 3px">
                <el-row>
                  <el-col :span="24">
                    <el-tabs type="border-card">
                      <el-tab-pane>
                        <span slot="label"><i class="el-icon-star-off"></i> Menus autorisés</span>
                        <div>
                          <el-table :data="detailUser.menu" height="400" style="width: 100%">
                            <el-table-column prop="libelle" label="Description">
                              <template slot-scope="scope">
                                <v-chip text-color="white" label color="primary">
                                  {{scope.row.libelle}}
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column prop="name" label="Route"></el-table-column>
                          </el-table>
                        </div>
                      </el-tab-pane>
                      <el-tab-pane label="Config">
                        <span slot="label"><i class="el-icon-document"></i> Rôles</span>
                        <div>
                          <el-table :data="detailUser.role" height="400" style="width: 100%">
                            <el-table-column prop="description" label="Description" width="350">
                              <template slot-scope="scope">
                                <v-chip text-color="white" label color="primary">
                                  {{scope.row.description}}
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column prop="route" label="Route"></el-table-column>
                          </el-table>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </el-col>
                </el-row>
              </div>
              <br/>
            </el-col>
          </el-row>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


  <!-- MODAL CHANGEMENT MOT DDE PASSE FACTURE -->
    <v-dialog v-model="dialogMdp" max-width="70%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Attribuer un mot de passe à l'utilisateur {{detailUser.nom}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogMdp = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text  element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-form v-model="valid" ref="formMdp" lazy-validation id="formMdp">
            <v-container fluid grid-list-md>
              <v-layout row justify-left>              
                <v-flex md4>
                  <v-text-field type="password" name="mdpNewUser" label="Nouveau mot de passe" v-model="mdpNewUser" :rules="mdpNewUserRules" :counter="4" required></v-text-field>
                </v-flex>
                <v-flex md4>
                  <v-text-field type="password" name="mdpNewVerUser" label="Confirmer le nouveau mot de passe" v-model="mdpNewVerUser" :rules="mdpNewVerUserRules" :counter="4" required></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-btn @click="clear" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="blue" @click="submitMdp" :disabled="!valid" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


    <!-- MODAL SHOW GROUPE DETAILS -->
    <v-dialog v-model="dialogShowGroup" max-width="90%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Détails du groupe {{ groupCourant.libelle }} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowGroup = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <el-card class="box-card"  style="background:#F9FAFC">
                  <div class="text item">
                    <h5>Libelle :<b> {{ groupCourant.libelle }} </b></h5> <br/>
                    <p>Créé le :<b> {{ groupCourant.created }} </b></p>
                    <p>Créé par :<b> {{ groupCourant.createur }} </b></p>
                  </div>
                </el-card>
              </div>
            </el-col>

            <el-col :span="16" >

              <div class="grid-content" style=" padding: 3px">
                <el-row>
                  <el-col :span="24">
                    <el-tabs type="border-card">
                      <el-tab-pane>
                        <span slot="label"><i class="el-icon-star-off"></i> Menus autorisés</span>
                        <div>
                          <v-spacer></v-spacer>
                          <v-text-field append-icon="search" label="Rechercher" single-line hide-details v-model="search"></v-text-field>
                          <v-data-table v-bind:headers="headersGroupMenus" v-bind:search="search" :items="groupeRoles.menus" class="elevation-1">
                            <template slot="headerCell" slot-scope="props">
                              <v-tooltip bottom>
                                <span slot="activator">
                                  {{ props.header.text }}
                                </span>
                                <span>
                                  {{ props.header.text }}
                                </span>
                              </v-tooltip>
                            </template>
                            <template slot="items" scope="props">
                              <td>
                                <v-chip outline text-color="primary" label color="primary">
                                  {{ props.item.nom }}
                                </v-chip>
                              </td>
                              <td>
                                <v-chip text-color="white" label color="primary">
                                  {{ props.item.libelle }}
                                </v-chip>
                              </td>
                            </template>
                          </v-data-table>
                        </div>
                      </el-tab-pane>
                      <el-tab-pane label="Config">
                        <span slot="label"><i class="el-icon-document"></i> Rôles</span>
                        <div>
                          <v-spacer></v-spacer>
                          <v-text-field append-icon="search" label="Rechercher" single-line hide-details v-model="search"></v-text-field>
                          <v-data-table v-bind:headers="headersGroupMenus" v-bind:search="search" :items="groupeRoles.routes" class="elevation-1">
                            <template slot-scope="props">
                              <v-tooltip bottom>
                                <span slot="activator">
                                  {{ props.header.text }}
                                </span>
                                <span>
                                  {{ props.header.text }}
                                </span>
                              </v-tooltip>
                            </template>
                            <template slot="items" scope="props">
                              <td>
                                <v-chip outline text-color="primary" label color="primary">
                                  {{ props.item.description }}
                                </v-chip>
                              </td>
                              <td>
                                <v-chip text-color="white" label color="primary">
                                  {{ props.item.route }}
                                </v-chip>
                              </td>
                            </template>
                          </v-data-table>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </el-col>
                </el-row>
              </div>
              <br/>
            </el-col>
          </el-row>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION -->
    <v-dialog v-model="dialogSupr" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h3 align="center">Voulez-vous vraiment supprimer cet enregistrement ?</h3>
          <p align="center">
            <v-btn @click.native="dialogSupr = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="red" @click.stop="deleteUser" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- TABLEAU -->
    <v-card-text v-if="droitAcces.index_user">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-card class="box-card" style="background:#fff">
              <div class="text item">
                <el-button icons @click="voirUser()" style="margin:5px; width:100%">Utilisateur<v-icon right>account_circle</v-icon></el-button>
                <div v-if="user.fonction == 'Super Administrateur'">
                  <el-button icons @click="voirResponsable()" style="margin:5px; width:100%">Responsable<v-icon right>accessibility</v-icon></el-button>
                  <el-button icons @click="voirRepresentant()" style="margin:5px; width:100%">Représentant de  zone<v-icon right>accessibility</v-icon></el-button>
                  <el-button icons @click="voirFourn()" style="margin:5px; width:100%">Prestataire<v-icon right>assignment</v-icon></el-button>
                  <el-button icons @click="voirGroup()" style="margin:5px; width:100%">Groupes<v-icon right>call_split</v-icon></el-button>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>

        <el-col :span="18">
          <div class="grid-content bg-purple">
            <el-card class="box-card" style="background:#fff">
              <!-- AFFICHER LES UTILISATEUR -->
              <el-tabs v-if="sessionUser">
                <el-tab-pane>
                  <span slot="label"> UTILISATEUR <v-icon right>account_circle</v-icon></span>
                  <!-- VUE D'ENSEMBLE -->
                  <el-row :gutter="20">
                    <v-container fluid grid-list-md>
                      <div v-if="droitAcces.create_user" class="text-xs-right">
                        <v-tooltip top>
                          <v-btn slot="activator" icons color="blue" @click.stop="newUser();" dark>Ajouter <v-icon right>add</v-icon></v-btn>
                          Ajouter un nouvel utilisateur
                        </v-tooltip>
                      </div>
                      <el-card class="box-card">
                        <v-card-title>
                          <v-chip text-color="white" label color="primary">
                            LISTE DES UTILISATEURS <v-icon right>account_circle</v-icon>
                          </v-chip>
                          <v-flex xs3 >
                            <el-col :span="2" >
                              <el-popover
                              ref="popover5"
                              placement="top"
                              width="180"
                              trigger="hover"
                              >
                                <p>Veuillez choisir le format d'impression ?</p>
                                <div style="text-align: right; margin: 0">
                                  <el-button type="success" size="mini" @click="imprimeListeUser('PDF')">PDF</el-button>
                                  <el-button type="primary" size="mini" @click="imprimeListeUser('EXC')">EXCEL</el-button>
                                </div>
                              </el-popover>
                                <div>
                                  <el-button v-popover:popover5 type="warning" :disabled="disabledBtnUs"
                                      icon="el-icon-printer" >Imprimer la liste
                                  </el-button>
                                </div>
                            </el-col>
                          </v-flex> <br/><br/>

                          <v-spacer></v-spacer>
                          <el-select
                                clearable
                                filterable
                                @clear="clearSelect()"
                                @change="filtrerEtatPrioriteBesoin"
                                v-model="rechercheUser"
                                placeholder="Rechercher un utilisateur"
                              >
                                <el-option
                                  v-for="item in listUser"
                                  :key="item.id"
                                  :label="item.nom"
                                  :value="item.id"
                                ></el-option>
                              </el-select>

                        </v-card-title>
                        <v-card-text>
                          <v-data-table  v-bind:headers="headers"  :items="listUser" class="elevation-1">
                            <template slot="headerCell" slot-scope="props">
                              <v-tooltip bottom>
                                <span slot="activator">
                                  {{ props.header.text }}
                                </span>
                                <span>
                                  {{ props.header.text }}
                                </span>
                              </v-tooltip>
                            </template>
                            <template slot="items" scope="props">
                              <td>
                                <v-avatar>
                                  <img v-if="props.item.url" :src="props.item.url" class="lazy" alt="">
                                  <img v-else :src="logoUser" class="lazy" alt="">
                                </v-avatar>
                              </td>
                              <td class="text-xs-right">
                                <v-chip text-color="white" label color="primary">
                                  {{ props.item.nom }}
                                </v-chip>
                              </td>
                              <td class="text-xs-right">
                                <v-chip outline text-color="primary" label color="primary">
                                  {{ props.item.email }}
                                </v-chip>
                              </td>
                              <td class="text-xs-right">{{ props.item.contact }}</td>
                              <td class="text-xs-center">
                                <div class="text-xs-center">
                                  <v-tooltip top>
                                    <v-btn v-if="droitAcces.user_show" slot="activator" @click.stop="showUser(props.item)" fab dark small color="green">
                                      <v-icon dark>folder_open</v-icon>
                                    </v-btn>
                                    Détails
                                  </v-tooltip>
                                  <v-tooltip top>
                                    <v-btn v-if="droitAcces.admin_profil_update_user" slot="activator" @click.stop="editUser(props.item)" fab dark small color="blue">
                                      <v-icon dark>edit</v-icon>
                                    </v-btn>
                                    Modifier
                                  </v-tooltip>
                                  <v-tooltip top>
                                    <v-btn v-if="droitAcces.role_user" slot="activator" @click.stop="newRole(props.item)" fab dark small color="orange">
                                      <v-icon dark>vpn_key</v-icon>
                                    </v-btn>
                                    Droit d'accès
                                  </v-tooltip>
                                  <v-tooltip top>
                                    <v-btn v-if="droitAcces.user_delete" slot="activator" @click.stop="dialogSupr = true; idUser = props.item.id;" fab dark small color="red">
                                      <v-icon dark>delete</v-icon>
                                    </v-btn>
                                    Supprimer
                                  </v-tooltip>
                                </div>
                              </td>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </el-card>
                    </v-container>
                  </el-row>
                </el-tab-pane>
              </el-tabs>

              <!-- AFFICHER LES REPRESENTANTS DE ZONE -->
              <el-tabs v-if="droitAcces.index_responsable_zone ">
                <el-tab-pane v-if="sessionResponsable">
                  <span slot="label"> REPRESENTANT DE ZONE <v-icon right>accessibility</v-icon></span>
                  <!-- VUE D'ENSEMBLE -->
                  <el-row :gutter="20">
                          <!-- MODULE RESPONSABLE ZONE -->
                      <Representant ></Representant>
                      <!-- MODULE RESPONSABLE ZONE -->
                  </el-row>
                </el-tab-pane>

                <!-- AFFICHER LES RESPONSABLE DE ZONE -->
                <el-tab-pane  v-if="sessionResponsableZone">
                  <span slot="label"> RESPONSABLE DE ZONE <v-icon right>accessibility</v-icon></span>

                  <!-- MODULE RESPONSABLE ZONE -->
                  <Responsable ></Responsable>
                  <!-- MODULE RESPONSABLE ZONE -->

                </el-tab-pane>

                 <!-- AFFICHER TECHNICIENS -->
                <el-tab-pane  v-if="sessionResponsableZone">
                  <span slot="label"> TECHNICIEN <v-icon right>accessibility</v-icon></span>

                  <!-- MODULE TECHNICIEN ZONE -->
                  <Technicien ></Technicien>
                  <!-- MODULE TECHNICIEN ZONE -->

                </el-tab-pane>
              </el-tabs>

              <!-- AFFICHER LES FOURNISSEURS QUI AURONT ACCES -->
              <el-tabs v-if="sessionFourn">
                <el-tab-pane>
                  <span slot="label"> PRESTATAIRE DESIGNE <v-icon right>assignment</v-icon></span>
                  <!-- VUE D'ENSEMBLE -->
                  <el-row :gutter="20">
                    <v-container fluid grid-list-md>
                      <el-card class="box-card">
                        <v-card-title>
                          <v-chip text-color="white" label color="primary">
                            LISTE DES PRESTATAIRES DESIGNES <v-icon right>assignment</v-icon>
                          </v-chip>

                          <v-flex xs3 >
                            <el-col :span="2" >
                              <el-popover
                              ref="popover5"
                              placement="top"
                              width="180"
                              trigger="hover"
                              >
                                <p>Veuillez choisir le format d'impression ?</p>
                                <div style="text-align: right; margin: 0">
                                  <el-button type="success" size="mini" @click="imprimeListePrest('PDF')">PDF</el-button>
                                  <el-button type="primary" size="mini" @click="imprimeListePrest('EXC')">EXCEL</el-button>
                                </div>
                              </el-popover>
                                <div>
                                  <el-button v-popover:popover5 type="warning" :disabled="disabledBtnPrest"
                                      icon="el-icon-printer" >Imprimer la liste
                                  </el-button>
                                </div>
                            </el-col>
                          </v-flex> <br/><br/>

                          <v-spacer></v-spacer>
                          <v-text-field append-icon="search" label="Rechercher" single-line hide-details v-model="recherche"></v-text-field>
                        </v-card-title>
                        <v-card-text>
                          <v-data-table v-bind:headers="headers" v-bind:search="recherche" :items="listFournisseur" class="elevation-1">
                            <template slot="headerCell" slot-scope="props">
                              <v-tooltip bottom>
                                <span slot="activator">
                                  {{ props.header.text }}
                                </span>
                                <span>
                                  {{ props.header.text }}
                                </span>
                              </v-tooltip>
                            </template>
                            <template slot="items" scope="props">
                              <td>
                                <v-avatar>
                                  <img v-if="props.item.url" :src="props.item.url" class="lazy" alt="">
                                  <img v-else :src="logoUser" class="lazy" alt="">
                                </v-avatar>
                              </td>
                              <td class="text-xs-right">
                                <v-chip text-color="white" label color="primary">
                                  {{ props.item.nom }}
                                </v-chip>
                              </td>
                              <td class="text-xs-right">
                                <v-chip outline text-color="primary" label color="primary">
                                  {{ props.item.email }}
                                </v-chip>
                              </td>
                              <td class="text-xs-right">{{ props.item.contact }}</td>
                              <td class="text-xs-center">
                                <div class="text-xs-center">
                                  <v-tooltip top>
                                    <v-btn v-if="droitAcces.user_show" slot="activator" @click.stop="showUser(props.item)" fab dark small color="green">
                                      <v-icon dark>folder_open</v-icon>
                                    </v-btn>
                                    Détails
                                  </v-tooltip>
                                  <v-tooltip top>
                                    <v-btn v-if="droitAcces.role_user" slot="activator" @click.stop="newRole(props.item)" fab dark small color="orange">
                                      <v-icon dark>vpn_key</v-icon>
                                    </v-btn>
                                    Droit d'accès
                                  </v-tooltip>
                                </div>
                              </td>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </el-card>
                    </v-container>
                  </el-row>
                </el-tab-pane>
              </el-tabs>


              <!-- AFFICHER LES GROUPES  -->
              <el-tabs v-if="sessionGroup">
                <el-tab-pane>
                  <span slot="label"> LISTE DES GROUPES <v-icon right>assignment</v-icon></span>
                  <!-- VUE D'ENSEMBLE -->
                  <el-row :gutter="20">
                    <v-container fluid grid-list-md>

                      <div class="text-xs-right">
                        <v-tooltip top>
                            <v-btn slot="activator" icons color="blue" @click.stop="newGroupe();" dark>Ajouter <v-icon right>add</v-icon></v-btn>
                            Ajouter un groupe
                        </v-tooltip>
                      </div>

                      <el-card class="box-card">
                        <v-card-title>
                          <v-chip text-color="white" label color="primary">
                            LISTE DES GROUPES <v-icon right>assignment</v-icon>
                          </v-chip>

                          <!-- <v-flex xs3 >
                            <el-col :span="2" >
                              <el-popover ref="popover5" placement="top" width="180" trigger="hover">
                                <p>Veuillez choisir le format d'impression ?</p>
                                <div style="text-align: right; margin: 0">
                                  <el-button type="success" size="mini" @click="imprimeListePrest('PDF')">PDF</el-button>
                                  <el-button type="primary" size="mini" @click="imprimeListePrest('EXC')">EXCEL</el-button>
                                </div>
                              </el-popover>
                                <div>
                                  <el-button v-popover:popover5 type="warning" :disabled="disabledBtnPrest"
                                      icon="el-icon-printer" >Imprimer la liste
                                  </el-button>
                                </div>
                            </el-col>
                          </v-flex> <br/><br/> -->

                          <v-spacer></v-spacer>
                          <v-text-field append-icon="search" label="Rechercher" single-line hide-details v-model="recherche"></v-text-field>
                        </v-card-title>
                        <v-card-text>
                          <v-data-table v-bind:headers="headersGroup" v-bind:search="recherche" :items="listGroupe" class="elevation-1">
                            <template slot="headerCell" slot-scope="props">
                              <v-tooltip bottom>
                                <span slot="activator">
                                  {{ props.header.text }}
                                </span>
                                <span>
                                  {{ props.header.text }}
                                </span>
                              </v-tooltip>
                            </template>
                            <template slot="items" scope="props">
                              <td class="text-xs-right">
                                <v-chip outline text-color="primary" label color="primary">
                                  {{ props.item.created }}
                                </v-chip>
                              </td>
                              <td class="text-xs-right">
                                <v-chip text-color="white" label color="primary">
                                  {{ props.item.libelle }}
                                </v-chip>
                              </td>
                              <td class="text-xs-right">
                                <v-chip outline text-color="primary" label color="primary">
                                  {{ props.item.description }}
                                </v-chip>
                              </td>
                              <td class="text-xs-center">
                                <div class="text-xs-center">
                                  <v-tooltip top>
                                    <v-btn v-if="droitAcces.user_show" slot="activator" @click.stop="showGroupe(props.item)" fab dark small color="green">
                                      <v-icon dark>folder_open</v-icon>
                                    </v-btn>
                                    Détails du groupe
                                  </v-tooltip>
                                  <v-tooltip top>
                                    <v-btn v-if="droitAcces.user_show" slot="activator" @click.stop="modalEditGroup(props.item)" fab dark small color="primary">
                                      <v-icon dark>edit</v-icon>
                                    </v-btn>
                                    Modifier
                                  </v-tooltip>
                                  <v-tooltip top>
                                    <v-btn v-if="droitAcces.role_user" slot="activator" @click.stop="attribuerRoleGroup(props.item)" fab dark small color="orange">
                                      <v-icon dark>vpn_key</v-icon>
                                    </v-btn>
                                    Droit d'accès
                                  </v-tooltip>
                                </div>
                              </td>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </el-card>
                    </v-container>
                  </el-row>
                </el-tab-pane>
              </el-tabs>







            </el-card>
          </div>
          <br/>
        </el-col>
      </el-row>
    </v-card-text>

  </div>
</template>

<script>
  import Loading from '@/components/Loading';
  import Responsable from "@/components/user/Responsable";
  import Technicien from "@/components/user/Technicien";
  import Representant from "@/components/user/Representant";
  export default {
    components:{ Loading,Responsable,Technicien,Representant  },
    name: 'User',
    data () {
      return {
        loading: false,
        domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
        user: JSON.parse(sessionStorage.getItem('userInfo')),
        roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
        droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
        menu:[],
        menuSele:[],
        roles:[],
        role: [],
        logoUser: "/static/avatar-conducteur.png",
        fileLogo: "",

        headers: [
          { text: 'Avatar', align: 'left', sortable: true, value: '' },
          { text: 'Nom et prénoms', value: 'a', sortable: true ,value:'Nom et prénoms'},
          { text: 'Login', value: '' , sortable: true},
          { text: 'Contact', value: 'Contact' , sortable: true},
          { text: 'Actions', align: 'center', value: 'Action', sortable: true }
        ],
        headersGroup: [
          { text: 'Date', value: 'created', sortable: true },
          { text: 'Nom', value: 'libelle', sortable: true },
          { text: 'Description', value: 'description', sortable: true },
          { text: 'Actions', align: 'center'}
        ],
        items: [
          { value: false, photo: '', nom: '', login: '', fonction: '', contact: '48867578', action: '' }
        ],
        racourcis: [
          { path: '/', text: 'Accueil', disabled: false },
          { path: '/user', text: 'Liste des utilisateurs', disabled: true }
        ],
        recherche: '',
        rechercheUser: '',
        sessionUser: true,
        sessionResponsable: false,
        sessionResponsableZone: false,
        sessionFourn: false,
        sessionGroup: false,
        dialogAjout: false,
        dialogRole: false,
        dialogAttRole: false,
        dialogEdit: false,
        dialogSupr: false,
        dialogShow: false,
        dialogShowGroup: false,
        dialogMdp: false,
        dialogImageUrl: '',
        dialogImageVisible: false,
        dialogAjoutGroupe: false,
        editGroup: false,
        valid: true,
        idUser: '',
        nomUser: '',
        photo: '',
        loginUser: '',
        emailUser: '',
        contactUser: '',
        fonctionUser: '',
        mdpNewVerUser:'',
        mdpNewUser:'',
        selectServiceUser: null,
        selectTypeUser: null,
        typeUser: [
          { text: "Membre de l'entreprise", value: 1 },
          //{ text: 'Representant de zone', value: 2 },
        ],
        selectPosteUser: null,
        posteUser: [
          { text: "Directeur du service technique", value: 1 },
          { text: 'Responsable délégué', value: 2 },
        ],
        listService: [],
        serviceUserRules: [
          (v) => !!v || 'Veuillez sélectionner votre service.',
        ],
        mdpUser: '',
        mdpVerUser: '',
        mdpUserConnect: '',
        loginUserRules: [
          (v) => !!v || 'Le E-mail est obligatoire',
          (v) => /^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
        ],
        nomUserRules: [
          (v) => !!v || 'Le nom est obligatoire',
          (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
        ],
        mdpUserRules: [
          (v) => !!v || 'Le mot de passe est obligatoire',
          (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
        ],
        mdpVerUserRules: [
          (v) => !!v || 'La vérifiaction du mot de passe est obligatoire. Il doit être identique au mot de pas entré précédenment',
          (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
        ],
        mdpUserConnectRules: [
          (v) => !!v || 'Votre mot de passe est obligatoire pour la confirmation'
        ],
        contactUserRules: [
          (v) => !!v || "Le contact de l'utilisateur est obligatoire",
          (v) => /[0-9]/.test(v) || 'Vous devez respecter format du contact'
        ],
        listUser: [],
        userCourant: [],
        detailUser: [],
        listResponsable: [],
        listFournisseur: [],
        listGroupe: [],
        groupCourant: [],
        disabledBtnUs: false,
        disabledBtnZone: false,
        disabledBtnPrest: false,
        formGroupe: {
          libelle: '',
          description: '',
        },
        GroupLIbRules: [
          v => !!v || 'Le libelle est obligatoire',
        ],
        listeGroupes:[],
        selectedGroup: [],
        UserGroupListe: [],
        allRoleMenus: [],
        allRoleRoutes: [],
        menusGrpActu: [],
        routesGrpActu: [],
        groupeRoles: {
          menus: [],
          routes: [],
        },
        search: '',
        headersGroupMenus: [
          { text: 'Nom', align: 'left', sortable: true,value: 'nom'},
          { text: 'Libelle',align: 'left', value: 'libelle' },
        ],
        mdpNewVerUserRules: [
                (v) => !!v || 'Veuillez confirmer le nouveau mot de passe.',
                (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
            ],
      mdpNewUserRules: [
            (v) => !!v || 'Le nouveau mot de passe est obligatoire.',
            (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
        ],
      }
    },
    computed: {
    },
    mounted () {
      this.loadService()
      this.loadUser()
      this.loadResponsable()
      this.loadFournisseur()
      this.loadPage()
    },
    methods: {
      loadPage ()
      {
        const loading = this.$loading({
          lock: true,
          text: 'Veuillez patientez ...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        setTimeout(() => {
          loading.close()
        }, 1000)
      },
      submitResetPassword ()
      {
        this.loading = true
        this.dialogPassword = false

        let url = this.domaine + 'userCreate/reset/password'
        let data = new FormData()
        data.append("username", this.detailUser.username)
        this.$http.post(url, data).then(response => {
          this.loading = false
          this.dialogShow = false
          if (response.body.code == 0) {
            this.$notify.error({
              title: 'Reinitialisation du mot de passe',
              message: "L'utilisateur n'exite pas"
            });
            return
          } else {
            this.$notify({
              type: 'success',
              title: 'Reinitialisation du mot de passe',
              message: "Le mot de passe a ete enregistre l'utilisateur recevra les identifiants par sms et mail"
            });
          }

        }, response => {
          this.dialogShow = false
          this.loading = false
          this.$notify.error({
            title: 'Reinitialisation du mot de passe',
            message: "Une erreur est survenue lors de la reinitialisation du mot de passe"
          });
        })
      },
      loadService () {
        let url = this.domaine + 'webService/liste-service'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listService = response.body.service
            this.menu = response.body.menu
            this.roles = response.body.role
          }
        })
      },
      loadUser () {

        let url = this.domaine + 'userCreate/user/'+ this.user.id +'/unique'
        if(this.droitAcces.index_user){
          url = this.domaine + 'userCreate/user-list'
        }

        this.$http.get(url).then(response => {
          if (response.body) {
            this.listUser = response.body
            if (this.listUser === undefined || this.listUser.length == 0) {
                this.disabledBtnUs = true
            } else{
              this.disabledBtnUs = false
            }
          }
        })
      },
      loadResponsable () {
        let url = this.domaine + 'userCreate/index/responsable/zone'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listResponsable = response.body
            if (this.listResponsable === undefined || this.listResponsable.length == 0) {
                this.disabledBtnZone = true
            } else{
              this.disabledBtnZone = false
            }
          }
        })
      },
      loadFournisseur () {
        let url = this.domaine + 'userCreate/index/fournisseur/designe'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listFournisseur = response.body
            if (this.listFournisseur === undefined || this.listFournisseur.length == 0) {
                this.disabledBtnPrest = true
            } else{
              this.disabledBtnPrest = false
            }
          }
        })
      },
      loadGroupe () {
        let url = this.domaine + 'userGroupe/index'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listGroupe = response.body
            if (this.listGroupe === undefined || this.listGroupe.length == 0) {
                this.disabledBtnPrest = true
            } else{
              this.disabledBtnPrest = false
            }
          }
        })
      },
      newUser () {
        this.dialogAjout = true
        this.userCourant.id = ''
        this.userCourant = {}
        this.nomUser = ''
        this.loginUser = ''
        this.emailUser = ''
        this.fonctionUser = ''
        this.selectServiceUser = null
        this.selectTypeUser = null
        this.selectPosteUser = null
        this.contactUser = ''
        this.mdpUser = ''
        this.mdpVerUser = ''
        // this.$refs["formFour"].resetFields();
      },
      newGroupe () {
        this.dialogAjoutGroupe = true
        this.editGroup = false
        this.formGroupe.libelle = ''
        this.formGroupe.description = ''
        this.groupCourant = []
      },
      SaveGroupe(){
        if (this.$refs.formGroup.validate()) {

          this.loading = true
          var form = document.getElementById('formGroup')
          var data = new FormData(form)
          data.append("idUSer", this.user.id)

          let url = ''
          if (this.groupCourant.id) {
            url = this.domaine + 'userGroupe/'+ this.groupCourant.id +'/edit'
          } else {
            url = this.domaine + 'userGroupe/new'
          }

          this.$http.post(url, data).then(response => {
            if (response.body.code == 1 || response.body.code == 2) {

              this.loading = false
              this.dialogAjoutGroupe = false
              this.loadGroupe()
              this.$notify({
                title: "LE GROUPE A BIEN ETE ENREGISTRE",
                message: 'Groupe enregistré avec succès.',
                type: 'success',
                position: 'top-center'
              })
            } else{

              this.loading = false
              this.$notify({
                title: "DESOLE CE NOM DE GROUPE EXISTE DEJA",
                message: 'Ce nom de groupe existe déja.',
                type: 'error',
                position: 'top-center'
              })
            }

          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loading = false
          })

        }
      },
      newRole (item) {
        // this.UserGroupListe = []

        this.loadAllGroupes()
          this.loadGroupeUser(item.id)
          //this.selectedGroup=[15,17]

        this.userCourant = item
        this.dialogRole = true
      },
      attribuerRoleGroup (item) {

        this.menusGrpActu = [];
        this.routesGrpActu = [];
        this.groupCourant = item
        this.dialogAttRole = true
        let url = this.domaine + 'userGroupe/load/'+ this.groupCourant.id +'/all'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.allRoleMenus = response.body.roleMenus
            this.menusGrpActu = response.body.menuGroup
            this.allRoleRoutes = response.body.roleRoutes
            this.routesGrpActu = response.body.routeGroup
          }
        })
      },
      loadAllGroupes () {

        // RECUP DE TS LES GROUP
        let url = this.domaine + 'userGroupe/index'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listeGroupes.splice(0);
            this.listeGroupes = response.body
          }
        })

      },
      loadGroupeUser(id)
      {
        // RECUP DES GROUP DU USER
        let lien = this.domaine + 'userGroupe/load/user/'+ id +'/groupe'
        this.$http.get(lien).then(response => {
          if (response.body) {
            this.selectedGroup.splice(0);
            response.body.forEach(element => {
            this.UserGroupListe.push(element)
                this.selectedGroup.push(element.id)

            });
          }
        })
      },
      voirUser () {
        this.sessionUser = true
        this.sessionResponsableZone = false
        this.sessionFourn = false
        this.sessionResponsable = false
        this.sessionGroup = false
      },
      voirResponsable (){
        this.sessionResponsableZone = true
        this.sessionResponsable = false
        this.sessionFourn = false
        this.sessionUser = false
        this.sessionGroup = false
      },
       voirRepresentant (){
        this.sessionResponsableZone = false
        this.sessionResponsable = true
        this.sessionFourn = false
        this.sessionUser = false
        this.sessionGroup = false
      },
      voirFourn () {
        this.sessionFourn = true
        this.sessionResponsableZone = false
        this.sessionResponsable = false
        this.sessionUser = false
        this.sessionGroup = false
      },

      voirGroup () {
        this.sessionFourn = false
        this.sessionResponsableZone = false
        this.sessionResponsable = false
        this.sessionUser = false
        this.sessionGroup = true
        this.loadGroupe ()
      },
      editUser (ligne) {
        this.dialogEdit = true
        this.dialogAjout = true

        this.userCourant = ligne
        this.nomUser = this.userCourant.nom
        this.loginUser = this.userCourant.username
        this.emailUser = this.userCourant.email
        this.fonctionUser = this.userCourant.fonction
        this.selectServiceUser = this.userCourant.serviceId
        this.contactUser = this.userCourant.contact
        this.selectTypeUser = this.userCourant.type
        this.selectPosteUser = this.userCourant.poste
        this.mdpUserConnect = ''
        this.logoUser = ligne.url
      },
      modalEditGroup (ligne) {
        this.dialogAjoutGroupe = true
        this.editGroup = true
        this.groupCourant = ligne
        this.formGroupe = this.groupCourant
      },
      showUser (ligne) {
        this.dialogShow = true
        this.userCourant = ligne
        let url = this.domaine + 'userCreate/show/' + this.userCourant.id
        this.$http.get(url).then(response => {
          if (response.body) {
            this.detailUser = response.body
          }
        })
      },


      showGroupe (ligne) {
        this.dialogShowGroup = true
        this.groupCourant = ligne
        let url = this.domaine + 'userGroupe/load/'+ ligne.id +'/groupe/unique/roles'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.groupeRoles.menus = response.body.Rmenus
            this.groupeRoles.routes = response.body.Rroutes
          }
        })
      },
      submitMdp () {
          this.loading = true
          if (this.$refs.formMdp.validate()) {
              if (this.mdpNewUser === this.mdpNewVerUser) {
                  var form = document.getElementById('formMdp')
                  var formdata = new FormData(form)
                  let url = this.domaine +'userCreate/'+ this.detailUser.id +'/edit/admin/password'
                  formdata.append('idUser', this.user.id)
                  this.$http.post(url, formdata).then(response => {
                          if (response.body) {
                              let verif = response.body
                              if (verif.code === 1) {
                                  this.$notify({
                                      title: "Mot de passe à bien été modifié",
                                      message: 'Modification éffectué avec succès.',
                                      type: 'success',
                                      position: 'top-center'
                                  })
                              } else if (verif.code === 2) {
                                  this.$message.error(verif.message)
                              } else if (verif.code === 3) {
                                  this.$message.error(verif.message)
                              } else if (verif.code === 0) {
                                  this.$message.error(verif.message)
                              }
                              this.loading = false
                              this.dialogMdp = false
                              this.loadPage()
                          } else {
                              this.$message.error('Erreur serveur')
                              this.loading = false
                          }
                      },
                      response => {
                          this.$message.error('Erreur serveur')
                          this.loading = false
                      })
              } else {
                  this.$message.error('Le mot de passe de vérification doit être identique au nouveau mot de passe')
                  this.loading = false
              }
          } else {
              this.$message.error('Veuillez renseigner les champs obligatoires')
              this.$notify.error({
                  title: "ERREUR D'ENREGISTREMENT",
                  message: "Utilisateur n'a pas été enregistré.",
                  position: 'top-center'
              })
              this.loading = false
          }
      },
      submit () {
        this.loading = true
        if (this.$refs.formUser.validate())
        {
            var form = document.getElementById('formUser')
            var formdata = new FormData(form)
            let url = ''
            if (this.userCourant.id) {
              url = this.domaine + 'userCreate/'+ this.userCourant.id +'/user/edit'
              formdata.append('mdpUser', this.mdpUserConnect)
            } else {
              url = this.domaine + 'userCreate/new'
            }
            formdata.append('idUser', this.user.id)
            formdata.append('serviceUser', this.selectServiceUser)
            formdata.append('nomUser', this.nomUser)
            formdata.append('loginUser', this.loginUser)
            formdata.append('contactUser', this.contactUser)
            formdata.append('fonctionUser', this.fonctionUser)
            // formdata.append('type', this.selectTypeUser)
            formdata.append('poste', this.selectPosteUser)
            formdata.append('roleUser', this.role)

            this.$http.post(url, formdata).then(response => {
              if (response.body) {
                let verif = response.body
                if (this.userCourant.id) {
                  if (verif.code === 1) {
                    this.$notify({
                      title: "L'UTILISATEUR A BIEN ETE MOFIFIE",
                      message: 'Modification effectué avec succès.',
                      type: 'success',
                      position: 'top-center'
                    })
                  this.loading = false
                  this.dialogAjout = false

                  } else if (verif.code === 2) {
                    this.loading = false
                    this.$message.error(verif.message)
                  } else if (verif.code === 3) {
                    this.loading = false
                    this.$message.error(verif.message)
                  } else if (verif.code === 4) {
                    this.loading = false
                    this.$message.error(verif.message)
                  } else if (verif.code === 5) {
                    this.loading = false
                    this.$message.error(verif.message)
                  } else if (verif.code === 0) {
                    this.loading = false
                    this.$message.error(verif.message)
                  }
                   this.loadUser()
                } else {
                  if (verif.code === 1) {
                    this.$notify({
                      title: "L'UTILISATEUR A BIEN ETE AJOUTE",
                      message: 'Enrégistrement réussie avec succès.',
                      type: 'success',
                      position: 'top-center'
                    })

                     this.loading = false
                    this.dialogAjout = false
                    this.loadUser()
                    this.loadResponsable()
                    this.loadFournisseur()
                    this.loadPage()

                  } else if (verif.code === 2) {
                     this.loading = false
                    this.$message.error(verif.message)
                  } else if (verif.code === 3) {
                     this.loading = false
                    this.$message.error(verif.message)
                  } else if (verif.code === 4) {
                     this.loading = false
                    this.$message.error(verif.message)
                  } else if (verif.code === 5) {
                     this.loading = false
                    this.$message.error(verif.message)
                  } else if (verif.code === 0) {
                    this.$message.error(verif.message)
                    this.loading = false
                    this.dialogAjout = false
                    this.loadUser()
                    this.loadResponsable()
                    this.loadFournisseur()
                    this.loadPage()
                  }
                }

              } else {
                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                this.loading = false
                this.dialogAjout = false
              }
            },
            response => {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
            })
          //} else {
            //this.$message.error('Le mot de passe de vérification doit être identique au mot de passe')
          //}
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "Utilisateur n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      imprimeListeUser (type) {
        let url = ""
        if(type == "PDF"){
            url = this.domaine+"userCreate/imprimerPDF/liste"
        }else {
            url = this.domaine+"userCreate/imprimerEXC/liste"
        }
        window.open(url)
      },
      filtrerEtatPrioriteBesoin(){
        //filtre de la liste de commande
      this.listUser = this.listUser.filter(element => {
        return element.id == this.rechercheUser;
      });
      },
      clearSelect() {
        this.loadUser();

    },
      imprimeListeRespoZone (type) {
        let url = ""
        if(type == "PDF"){
            url = this.domaine+"userCreate/imprimerPDF/responsable/liste"
        }else {
            url = this.domaine+"userCreate/imprimerEXC/responsable/liste"
        }
        window.open(url)
      },
      imprimeListePrest (type) {
        let url = ""
        if(type == "PDF"){
            url = this.domaine+"userCreate/imprimerPDF/prestataire/liste"
        }else {
            url = this.domaine+"userCreate/imprimerEXC/prestataire/liste"
        }
        window.open(url)
      },
      submitRole () {
        this.loading = true
        if (this.$refs.formRole.validate()) {
          var form = document.getElementById('formRole')
          var data = new FormData(form)
          let url = this.domaine + 'userCreate/'+ this.userCourant.id +'/role/user'
          data.append('idUser', this.user.id)
          data.append('selectGroups', JSON.stringify(this.selectedGroup))

          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: 'Droits enregistré avec succès,veuillez vous reconnecter pour appliquer les changements',
                  type: 'success',
                    DURATION:10000,
                  position: 'top-center'
                })
              }

              this.loading = false
              this.dialogRole = false
              this.loadUser()
              this.loadResponsable()
              this.loadFournisseur()
              this.loadPage()
              this.$refs.formRole.reset()
              let menu = verif.menu
              let droit = verif.role
              //sessionStorage.setItem('sessionAcces', JSON.stringify(menu))
              //sessionStorage.setItem('sessionDroit', JSON.stringify(droit))
              //this.roleAcces = JSON.parse(sessionStorage.getItem('sessionAcces'))
              //this.droitAcces = JSON.parse(sessionStorage.getItem('sessionDroit'))
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
              this.dialogRole = false
            }
          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loading = false
          })
        } else {
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "Utilisateur n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      deleteUser () {
        let url = this.domaine + 'userCreate/delete/' + this.idUser
        this.$http.get(url).then(response => {
          if (response.body) {
            if (response.body.code === 1) {
              this.$notify({
                title: 'SUPPRESSION',
                message: "L'utilisateur à supprimé avec succès.",
                type: 'success',
                position: 'top-center'
              })
              this.dialogSupr = false
              this.loadUser()
              this.loadPage()
            } else if(response.body.code === -2) {
              this.$notify.error({
                title: 'SUPPRESSION IMPOSSIBLE',
                message: 'Impossible de supprimer cet utilisateur car il présent dans un projet.',
                position: 'top-center'
              })
            } else {
              this.$notify.error({
                title: 'SUPPRESSION ECHOUE',
                message: 'La suppression de l\'utilisateur à échoue.',
                position: 'top-center'
              })
            }
          }
        })
      },
      //enregistrement des images
            onFileImageLogoPicked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.logoUser = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.logoUser = files[0]

            },




      submitAttRoles () {

        // this.loading = true
        var data = new FormData()
        data.append('idGroup', this.groupCourant.id)
        data.append('RoleMenus', JSON.stringify(this.menusGrpActu))
        data.append('RoleRoutes', JSON.stringify(this.routesGrpActu))

        let url = this.domaine + 'userGroupe/roles/attribution/groupe'

        this.$http.post(url, data).then(response => {
          if (response.body.code == 1) {

            this.$notify({
              type: 'success',
              title: 'Roles attribues avec succes',
              message: "Role attribue avec succes"
            });
            this.dialogAttRole = false
            this.loadGroupe()
            this.loading = false
          }
        },
        response => {
          this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
          this.loading = false
        })
      },


      clear () {
        this.$refs.formUser.reset()
        this.dialogAjout = false
      }
    },
    // beforeMount: function () {
    //   if(!this.roleAcces[this.$router.history.current.name]){
    //     this.$router.push({ name: 'Home'  })
    //   }
    // }
  }
</script>



// WEBPACK FOOTER //
// src/components/User.vue